// extracted by mini-css-extract-plugin
export var actions = "_mg-5";
export var assistantBubble = "_mg-3";
export var assistantRow = "_mg-6";
export var bubble = "_mg-0";
export var humanAvatar = "_mg-4";
export var inlineToolCard = "_mg-1";
export var userBubble = "_mg-2";